<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div
        class="inputContainer"
        :class="{ 'waffle-chip-choices-invalid': error && hasBeenInteractedWith, 'container-menu-opened': true,  'border-setup': !hasBeenInteractedWith, }"
        role="combobox"
        aria-haspopup="listbox"
        @keydown.enter="confirm"
        @blur="$emit('user-interaction'); confirm;"
        @tab="confirm"
        v-bind="$attrs"
        ref="chipContainer"
    >
      <div class="d-flex flex-wrap " :class="{'waffle-chip-choices-container':true}">
        <div id="values-output" v-for="(selection, i) in question?.options ?? []" :key="`${selection.value}_${i}`">
          <div class="d-inline-block waffle-chip-choices-chip me-2 mb-2" tabindex="0" :class="{'waffle-chip-choices-selected': selectedValues[selection.value]}"
               @keydown.space.stop.prevent="selectedValues[selection.value] = !selectedValues[selection.value]"
               @click.stop.prevent="selectedValues[selection.value] = !selectedValues[selection.value];focused=true">
            <span data-testid="selected-value">{{ selection?.text }}</span>
          </div>
        </div>
      </div>

    </div>
    <slot name="helptext" :isConfirm="!disableConfirm && (question.value && question?.prefilled) && !error" :isError="error"
          :confirmCb="() => {$emit('user-interaction');$emit('confirm');}"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="Object.keys(selectedValues).length ? Object.keys(selectedValues).filter(k => selectedValues[k]).join(','):'-'"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>

<script>
import ReadOnly from "@/components/themeable-components/ReadOnly.vue";

export default {
  name: "ChipChoices",
  components: {ReadOnly},
  props: {
    disableConfirm:Boolean,
    question: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: [String, Object],
      required: false,
    },
    hideSubText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    forcePromptPlaceholder: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    skipEagerValidation: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    hasBeenInteractedWith:Boolean,
    disabled:Boolean
  },
  data() {
    return {
      selectedValues: {},
      error: "",
      shouldConfirm: false,
      focused:false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
    this.question.value?.split(',').forEach(value => {
      const found = (this.question.options || [])?.find((item) => {
        return item?.value?.includes(value)
      })
      if (found) {
        this.selectedValues[found.value] = true
      } else {
        this.selectedValues[value] = false;
      }
    })

    if (
        this.question.required &&
        !Object.values(this.selectedValues).some(el => el) &&
        !this.skipEagerValidation
    ) {
      this.error = "Required";
      return this.$emit("field-error", true);
    }
  },
  emits: ["update:modelValue", "field-error",'confirm','user-interaction'],
  watch: {
    selectedValues: {
      handler() {
        const result = Object.keys(this.selectedValues)?.filter(k => this.selectedValues[k])?.join(',')
        if (!result?.length && this.question.required) {
          this.error = "Required";
          this.$emit("field-error", true);
        } else {
          this.error = "";
          // if(this.disableConfirm){
          //   this.confirm()
          // }
          this.$emit("field-error", false);
        }
      },
      deep: true
    },
    question: {
      handler(newQuestion) {
        if (newQuestion.error) {
          this.error = newQuestion.error;
          return this.$emit("field-error", true);
        }
        if (newQuestion.value) {
          const currentResult = Object.keys(this.selectedValues)?.filter(k => this.selectedValues[k])?.join(',')
          if(newQuestion.value !== currentResult){
            this.$emit('update:modelValue',newQuestion.value );
          }
          newQuestion.value?.split(',').forEach(value => {
            const found = (newQuestion.options || [])?.find((item) => {
              return item?.value?.includes(value)
            })
            if (found) {
              this.selectedValues[found.value] = true
            } else {
              this.selectedValues[value] = false;
            }
          })
        }
      }
      ,
      deep: true,
    }
    ,
  },
  beforeUnmount() {
    // Remove the click event listener when the component is unmounted
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    handleDocumentClick(event) {
      this.$emit('user-interaction')
      const divElement = this.$refs.chipContainer; // Access the div using the ref
      if (divElement && !divElement.contains(event.target)) {
        this.confirm();
      }
    },
    confirm() {
      if(this.focused){
        this.$emit('update:modelValue', Object.keys(this.selectedValues)?.filter(k => this.selectedValues[k])?.join(','));
        if(this.question.value && !this.disableConfirm){
          this.$emit('confirm')
        }
      }
      this.focused = false
    },
    handleKeyDown(e) {
      if (e.key === "space") {
        e.preventDefault()

      }
    }
    ,
  }
  ,
}
;
//TODO:CLEAN UP AND REFINE CSS
</script>